<div class="config-panel">
  <!-- X-Axis Binning -->
  <div class="config-section">
    <div class="config-label">X-AXIS BINNING</div>
    <mat-button-toggle-group
      class="custom-toggle-group size-xs"
      hideSingleSelectionIndicator
      [value]="binningMode()"
      (change)="onBinningModeChange($event.value)"
    >
      <mat-button-toggle value="count">Count</mat-button-toggle>
      <mat-button-toggle value="width">Width</mat-button-toggle>
      <mat-button-toggle value="custom">Custom</mat-button-toggle>
    </mat-button-toggle-group>
    <span class="config-hint">{{ binningDescription() }}</span>
  </div>

  <!-- Binning Parameter -->
  <div class="config-section">
    @switch (binningMode()) {
      @case ('count') {
        <div class="config-label">
          NUMBER OF BINS
          <span class="config-value">{{ binCountCtrl.value }}</span>
        </div>
        <input
          type="range"
          class="config-slider"
          min="2"
          max="50"
          step="1"
          [value]="binCountCtrl.value"
          (input)="onBinCountSlider($any($event.target).valueAsNumber)"
        />
      }
      @case ('width') {
        <div class="config-label">BIN WIDTH</div>
        <dojo-number-input [formCtrl]="binWidthCtrl" [compact]="true" />
      }
      @case ('custom') {
        <div class="config-label">BOUNDARIES</div>
        <mat-chip-grid #chipGrid class="boundary-chips">
          @for (b of boundaries(); track b) {
            <mat-chip-row (removed)="removeBoundary(b)">
              {{ b }}
              <button matChipRemove>×</button>
            </mat-chip-row>
          }
          <input
            class="chip-input"
            placeholder="Add boundary…"
            [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
            (matChipInputTokenEnd)="addBoundary($event)"
          />
        </mat-chip-grid>
      }
    }
  </div>

  <!-- Y-Axis Type -->
  <div class="config-section">
    <div class="config-label">Y-AXIS</div>
    <mat-button-toggle-group
      class="custom-toggle-group size-xs"
      hideSingleSelectionIndicator
      [value]="yAxisType()"
      (change)="onYAxisTypeChange($event.value)"
    >
      <mat-button-toggle value="frequency">Frequency</mat-button-toggle>
      <mat-button-toggle value="relative-frequency">Relative</mat-button-toggle>
      <mat-button-toggle value="frequency-density">Density</mat-button-toggle>
    </mat-button-toggle-group>
    <span class="config-hint">{{ yAxisDescription() }}</span>
  </div>

  <!-- Start Boundary (not applicable for custom boundaries) -->
  @if (binningMode() !== 'custom') {
    <div class="config-section">
      <div class="config-label">START BOUNDARY</div>
      <dojo-text-input [formCtrl]="startBoundaryTextCtrl" [compact]="true" placeholder="Leave empty for auto" />
    </div>
  }
</div>
